/*
  Lior Apple layer: motion for sections/lior-apple-explore.liquid ("Take a closer look").
  - First view: the headline and the stage wait (.lex-pre) until they come into
    view, then arrive (.is-in). Content that is already on screen is never hidden.
  - A pill or a point opens its card. A sheet of glass (.lex-glass) glides from
    the pill to the card while the list fades away, and the photo glides in to
    the point (or the point's video fades in and plays). Closing runs it back.
  - The arrows (and the left/right keys) step between points: the glass reshapes
    from one card to the next, the words cross-fade and the photo pans across.
  - Every move can be interrupted; the next one starts from wherever the glass is.
  - Hovering a pill lights its point on the photo, and the other way round.
  The first-view entrance is skipped in the theme editor (choosing a block
  there opens its card), and with reduced motion nothing glides at all.
*/
(function () {
  'use strict';

  if (window.__liorExplore) return;
  window.__liorExplore = true;

  var doc = document;
  var win = window;
  var mq = function (q) { return win.matchMedia ? win.matchMedia(q) : { matches: false }; };
  var reduce = mq('(prefers-reduced-motion: reduce)');
  var designMode = !!(win.Shopify && win.Shopify.designMode);
  var hasIO = 'IntersectionObserver' in win;
  var rtl = (doc.documentElement.getAttribute('dir') || '').toLowerCase() === 'rtl';

  var OPEN_MS = 660;
  var CLOSE_MS = 500;
  var SWAP_MS = 560;
  var instances = [];

  function px(n) { return Math.round(n * 10) / 10 + 'px'; }
  function clamp(v, lo, hi) { return Math.min(hi, Math.max(lo, v)); }
  function each(list, fn) { for (var i = 0; i < list.length; i++) fn(list[i], i); }
  function own(obj, fn) { for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k)) fn(obj[k], k); }

  function focusQuietly(el) {
    if (!el || typeof el.focus !== 'function') return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  function inView(el, frac) {
    var r = el.getBoundingClientRect();
    var vh = win.innerHeight || doc.documentElement.clientHeight;
    return r.top < vh * frac && r.bottom > 0;
  }

  function quietPlay(v) {
    var p = v.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  /*
   * First view
   */
  var revealIO = hasIO ? new IntersectionObserver(function (entries) {
    each(entries, function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      revealIO.unobserve(el);
      requestAnimationFrame(function () { el.classList.add('is-in'); });
      /* Once everything has arrived, drop the entrance state so hovers answer at once */
      setTimeout(function () { el.classList.remove('lex-pre', 'is-in'); }, 2800);
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }) : null;

  var visibleIO = hasIO ? new IntersectionObserver(function (entries) {
    each(entries, function (entry) {
      entry.target.classList.toggle('is-visible', entry.isIntersecting);
      if (entry.target.__lex) entry.target.__lex.onVisible(entry.isIntersecting);
    });
  }) : null;

  /*
   * One section
   */
  function setup(root) {
    if (root.__lex) return root.__lex;

    var frame = root.querySelector('[data-lex-frame]');
    var zoomEl = root.querySelector('[data-lex-zoom]');
    var panel = root.querySelector('[data-lex-panel]');
    var list = root.querySelector('[data-lex-list]');
    var glass = root.querySelector('[data-lex-glass]');
    if (!frame || !zoomEl || !panel || !list || !glass) return null;

    var ids = [];
    var pills = {};
    var dots = {};
    var cards = {};
    var medias = {};

    each(list.querySelectorAll('.lex-pill[data-lex-point]'), function (el) {
      var id = el.getAttribute('data-lex-point');
      ids.push(id);
      pills[id] = el;
    });
    each(root.querySelectorAll('.lex-dot[data-lex-point]'), function (el) { dots[el.getAttribute('data-lex-point')] = el; });
    each(root.querySelectorAll('[data-lex-card]'), function (el) { cards[el.getAttribute('data-lex-card')] = el; });
    each(root.querySelectorAll('[data-lex-media]'), function (el) { medias[el.getAttribute('data-lex-media')] = el; });

    var zoom = parseFloat(root.getAttribute('data-zoom'));
    if (!(zoom >= 1)) zoom = 1.4;

    var active = null;
    var onScreen = true;
    var timer = null;
    var finish = null;

    /* The end of the current move, run now when a new one starts */
    function settle() {
      if (timer) { clearTimeout(timer); timer = null; }
      var f = finish;
      finish = null;
      if (f) f();
    }

    function later(ms, fn) {
      finish = fn;
      if (reduce.matches) { settle(); return; }
      timer = setTimeout(function () {
        timer = null;
        var f = finish;
        finish = null;
        if (f) f();
      }, ms);
    }

    /* Geometry, relative to the panel */
    function boxOf(el) {
      var a = el.getBoundingClientRect();
      var b = panel.getBoundingClientRect();
      return { top: a.top - b.top, left: a.left - b.left, width: a.width, height: a.height };
    }

    function radiusOf(el, fallback) {
      var r = parseFloat(win.getComputedStyle(el).borderTopLeftRadius);
      if (isNaN(r)) return fallback;
      return Math.min(r, el.offsetHeight / 2 || r);
    }

    /* The travelling glass */
    function glassAt(shape) {
      var s = glass.style;
      s.transition = 'none';
      s.top = px(shape.box.top);
      s.left = px(shape.box.left);
      s.width = px(shape.box.width);
      s.height = px(shape.box.height);
      s.borderRadius = px(shape.radius);
      glass.classList.add('is-on');
      void glass.offsetWidth;
    }

    function glassTo(shape, ms) {
      var s = glass.style;
      var e = ' ' + ms + 'ms var(--lex-ease)';
      s.transition = 'top' + e + ', left' + e + ', width' + e + ', height' + e + ', border-radius' + e;
      s.top = px(shape.box.top);
      s.left = px(shape.box.left);
      s.width = px(shape.box.width);
      s.height = px(shape.box.height);
      s.borderRadius = px(shape.radius);
    }

    function glassOff() {
      glass.style.transition = 'none';
      glass.classList.remove('is-on');
    }

    /* Where the glass is right now, even half way through a move */
    function glassNow() {
      return glass.classList.contains('is-on') ? { box: boxOf(glass), radius: radiusOf(glass, 28) } : null;
    }

    function shapeOf(el) {
      return { box: boxOf(el), radius: radiusOf(el, 28) };
    }

    /* Phones: the panel grows and shrinks smoothly instead of jumping */
    function holdHeight(from, to, ms) {
      if (reduce.matches || Math.abs(from - to) < 1) { releaseHeight(); return; }
      var s = panel.style;
      s.transition = 'none';
      s.height = px(from);
      void panel.offsetHeight;
      s.transition = 'height ' + ms + 'ms var(--lex-ease)';
      s.height = px(to);
    }

    function releaseHeight() {
      panel.style.transition = '';
      panel.style.height = '';
    }

    /* The photo glides in so the point sits as near the middle as the edges allow */
    function setZoom(id) {
      var dot = id ? dots[id] : null;
      var W = zoomEl.offsetWidth;
      var H = zoomEl.offsetHeight;
      if (!dot || !W || !H || dot.offsetParent === null) { unzoom(); return; }
      var cx = dot.offsetLeft + dot.offsetWidth / 2;
      var cy = dot.offsetTop + dot.offsetHeight / 2;
      var tx = clamp(W / 2 - zoom * cx, W - zoom * W, 0);
      var ty = clamp(H / 2 - zoom * cy, H - zoom * H, 0);
      zoomEl.style.setProperty('--tx', px(tx));
      zoomEl.style.setProperty('--ty', px(ty));
      zoomEl.style.setProperty('--s', String(zoom));
      frame.style.setProperty('--lex-ds', String(Math.round(10000 / zoom) / 10000));
      frame.classList.add('is-zoomed');
    }

    function unzoom() {
      zoomEl.style.setProperty('--tx', '0px');
      zoomEl.style.setProperty('--ty', '0px');
      zoomEl.style.setProperty('--s', '1');
      frame.style.setProperty('--lex-ds', '1');
      frame.classList.remove('is-zoomed');
    }

    /* A point's video: fades in and plays from the start; others fade and pause */
    function showMedia(m) {
      var v = m.querySelector('video');
      m.classList.add('is-on');
      if (!v) return;
      v.muted = true;
      v.playsInline = true;
      if (v.paused) {
        try { v.currentTime = 0; } catch (e) { /* not loaded yet: it starts at 0 anyway */ }
      }
      if (onScreen) quietPlay(v);
    }

    function hideMedia(m) {
      if (!m.classList.contains('is-on')) return;
      m.classList.remove('is-on');
      var v = m.querySelector('video');
      if (!v) return;
      setTimeout(function () {
        if (!m.classList.contains('is-on')) v.pause();
      }, reduce.matches ? 0 : 720);
    }

    function setMedia(id) {
      own(medias, function (m, k) {
        if (k === id) showMedia(m);
        else hideMedia(m);
      });
    }

    function mark(id, on) {
      var v = on ? 'true' : 'false';
      if (pills[id]) pills[id].setAttribute('aria-expanded', v);
      if (dots[id]) dots[id].setAttribute('aria-expanded', v);
    }

    /* Keep the photo and the open card in sight together: when both fit, scroll
       only as far as needed to show them; when the card is too long, bring the
       top of the photo up under the header and let the words run below. */
    function bringIntoView(card) {
      var vh = win.innerHeight || doc.documentElement.clientHeight;
      var headGap = 76;
      var footGap = 16;
      var f = frame.getBoundingClientRect();
      var c = card.getBoundingClientRect();
      var top = Math.min(f.top, c.top);
      var bottom = Math.max(f.bottom, c.bottom);
      var by = 0;
      if (bottom - top <= vh - headGap - footGap) {
        if (top < headGap) by = top - headGap;
        else if (bottom > vh - footGap) by = bottom - (vh - footGap);
      } else if (Math.abs(f.top - headGap) > 40) {
        by = f.top - headGap;
      }
      if (Math.abs(by) < 2) return;
      try { win.scrollBy({ top: by, behavior: reduce.matches ? 'auto' : 'smooth' }); } catch (e) { win.scrollBy(0, by); }
    }

    function open(id, opts) {
      opts = opts || {};
      var card = cards[id];
      if (!card || id === active) return;
      if (active !== null) { swap(id, opts); return; }

      var flying = glassNow();
      var h0 = panel.offsetHeight;
      settle();

      var pill = pills[id];
      active = id;
      mark(id, true);
      root.classList.add('is-open');

      card.hidden = false;
      card.classList.remove('is-solid', 'is-shown', 'is-leaving');
      card.style.top = '';
      var h1 = panel.offsetHeight;
      var start = flying || (pill && pill.offsetParent !== null ? shapeOf(pill) : null);
      var end = shapeOf(card);
      var li = pill ? pill.closest('.lex-li') : null;

      list.classList.add('is-away');
      list.setAttribute('inert', '');
      holdHeight(h0, h1, OPEN_MS);
      setZoom(id);
      setMedia(id);

      if (start && !reduce.matches) {
        if (li && !flying) li.classList.add('is-landing'); /* the pill becomes the glass */
        glassAt(start);
        glassTo(end, OPEN_MS);
      }
      requestAnimationFrame(function () { card.classList.add('is-shown'); });
      if (opts.focus !== false) focusQuietly(card);
      if (opts.reveal) bringIntoView(card);

      later(OPEN_MS + 30, function () {
        card.classList.add('is-solid');
        if (li) li.classList.remove('is-landing');
        glassOff();
        releaseHeight();
      });
    }

    function swap(id, opts) {
      var flying = glassNow();
      var h0 = panel.offsetHeight;
      settle();

      var oldId = active;
      var oldCard = cards[oldId];
      var card = cards[id];
      var hadFocus = oldCard.contains(doc.activeElement);
      var start = flying || shapeOf(oldCard);

      mark(oldId, false);
      mark(id, true);
      active = id;

      /* The old words fade where they stand, out of the flow */
      var top = oldCard.offsetTop;
      oldCard.classList.remove('is-shown', 'is-solid');
      oldCard.classList.add('is-leaving');
      oldCard.style.top = px(top);

      card.hidden = false;
      card.classList.remove('is-solid', 'is-shown', 'is-leaving');
      card.style.top = '';
      var h1 = panel.offsetHeight;
      holdHeight(h0, h1, SWAP_MS);
      setZoom(id);
      setMedia(id);

      if (!reduce.matches) {
        glassAt(start);
        glassTo(shapeOf(card), SWAP_MS);
      }
      requestAnimationFrame(function () { card.classList.add('is-shown'); });

      if (hadFocus) {
        var next = null;
        if (opts.dir) {
          next = card.querySelector('[data-lex-step="' + opts.dir + '"]');
          if (next && next.disabled) next = card.querySelector('[data-lex-step="' + -opts.dir + '"]');
        }
        focusQuietly(next || card);
      }
      if (opts.reveal) bringIntoView(card);

      later(SWAP_MS + 30, function () {
        oldCard.hidden = true;
        oldCard.classList.remove('is-leaving');
        oldCard.style.top = '';
        card.classList.add('is-solid');
        glassOff();
        releaseHeight();
      });
    }

    function close(opts) {
      opts = opts || {};
      if (active === null) return;

      var flying = glassNow();
      var h0 = panel.offsetHeight;
      settle();

      var id = active;
      var card = cards[id];
      var pill = pills[id];
      var hadFocus = card.contains(doc.activeElement);
      var start = flying || shapeOf(card);

      active = null;
      mark(id, false);
      root.classList.remove('is-open');

      card.classList.remove('is-shown', 'is-solid');
      card.classList.add('is-closing');
      list.classList.remove('is-away');
      list.removeAttribute('inert');
      /* The panel's resting height without the card (on wide screens it stays as tall as the photo) */
      card.hidden = true;
      var h1 = panel.offsetHeight;
      card.hidden = false;
      var li = pill ? pill.closest('.lex-li') : null;
      holdHeight(h0, h1, CLOSE_MS);
      unzoom();
      setMedia(null);

      if (pill && !reduce.matches) {
        if (li) li.classList.add('is-landing'); /* the glass becomes the pill again */
        glassAt(start);
        glassTo(shapeOf(pill), CLOSE_MS);
      }
      if ((hadFocus || opts.focusPill) && pill) focusQuietly(pill);

      later(CLOSE_MS + 30, function () {
        card.hidden = true;
        card.classList.remove('is-closing');
        if (li) li.classList.remove('is-landing');
        glassOff();
        releaseHeight();
      });
    }

    function step(dir) {
      if (active === null) return;
      var i = ids.indexOf(active) + dir;
      if (i < 0 || i >= ids.length) return;
      open(ids[i], { dir: dir, reveal: true });
    }

    /*
     * Wiring
     */
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      if (t.closest('[data-lex-close]')) {
        close({ focusPill: true });
        return;
      }

      var stepper = t.closest('[data-lex-step]');
      if (stepper) {
        if (!stepper.disabled) step(parseInt(stepper.getAttribute('data-lex-step'), 10) || 0);
        return;
      }

      var point = t.closest('[data-lex-point]');
      if (!point || !root.contains(point)) return;
      var id = point.getAttribute('data-lex-point');
      var viaDot = point.classList.contains('lex-dot');
      if (viaDot && id === active) {
        close({});
        return;
      }
      open(id, { focus: !viaDot, reveal: true });
    });

    root.addEventListener('keydown', function (e) {
      if (active === null) return;
      var k = e.key;
      if (k === 'Escape' || k === 'Esc') {
        e.preventDefault();
        close({ focusPill: true });
        return;
      }
      if (!panel.contains(doc.activeElement)) return;
      var dir = 0;
      if (k === 'ArrowRight') dir = rtl ? -1 : 1;
      else if (k === 'ArrowLeft') dir = rtl ? 1 : -1;
      if (!dir) return;
      e.preventDefault();
      step(dir);
    });

    /* A pill and its point light up together */
    function hint(e, on) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      var el = e.target && e.target.closest ? e.target.closest('[data-lex-point]') : null;
      if (!el || !root.contains(el)) return;
      if (e.relatedTarget && el.contains(e.relatedTarget)) return;
      var id = el.getAttribute('data-lex-point');
      if (pills[id]) pills[id].classList.toggle('is-hint', on);
      if (dots[id]) dots[id].classList.toggle('is-hint', on);
    }

    root.addEventListener('pointerover', function (e) { hint(e, true); });
    root.addEventListener('pointerout', function (e) { hint(e, false); });

    var api = {
      root: root,
      open: open,
      close: close,
      relayout: function () { if (active !== null) setZoom(active); },
      onVisible: function (on) {
        onScreen = on;
        own(medias, function (m, k) {
          var v = m.querySelector('video');
          if (!v) return;
          if (!on) v.pause();
          else if (k === active) quietPlay(v);
        });
      },
      teardown: function () {
        settle();
        own(medias, function (m) {
          var v = m.querySelector('video');
          if (v) v.pause();
        });
        if (visibleIO) visibleIO.unobserve(root);
        instances = instances.filter(function (x) { return x !== api; });
      }
    };
    root.__lex = api;
    instances.push(api);

    if (visibleIO) visibleIO.observe(root);
    else root.classList.add('is-visible');

    if (!designMode && !reduce.matches && revealIO) {
      each([root.querySelector('[data-lex-head]'), root.querySelector('[data-lex-stage]')], function (el) {
        if (!el || inView(el, 0.92)) return; /* already in sight: leave it as it is */
        el.classList.add('lex-pre');
        revealIO.observe(el);
      });
    }

    return api;
  }

  function scan(scope) {
    each((scope || doc).querySelectorAll('[data-lex]'), setup);
  }

  function instanceFor(el) {
    var root = el && el.closest ? el.closest('[data-lex]') : null;
    return root ? root.__lex || setup(root) : null;
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();

  var raf = 0;
  win.addEventListener('resize', function () {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = 0;
      each(instances.slice(), function (inst) {
        if (inst.root.isConnected) inst.relayout();
        else inst.teardown();
      });
    });
  });

  /* Theme editor */
  doc.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  doc.addEventListener('shopify:section:unload', function (e) {
    each(e.target.querySelectorAll('[data-lex]'), function (root) {
      if (root.__lex) root.__lex.teardown();
    });
  });
  doc.addEventListener('shopify:block:select', function (e) {
    var inst = instanceFor(e.target);
    if (inst && e.detail && e.detail.blockId) inst.open(e.detail.blockId, { focus: false });
  });
  doc.addEventListener('shopify:block:deselect', function (e) {
    var inst = instanceFor(e.target);
    if (inst) inst.close({});
  });
})();
